import { fetchOfferListFilters } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'
import getOfferListKey from 'lib/offer/offerListKey'
import { useEffect } from 'react'

export const emptyFilters: App.OfferListFilterOptions = {
  error: undefined,
  fetching: true,
  filterOrder: {
    amenities: {},
    holidayTypes: {},
  },
  filters: {
    amenities: {},
    bedrooms: {},
    campaigns: {},
    holidayTypes: {},
    offerTypes: {},
    propertyTypes: {},
    luxPlusFeatures: {},
    agentHubFeatures: {},
    total: 0,
  },
  orderedFilters: {
    amenities: [],
    holidayTypes: [],
  },
}

interface Options {
  disabled?: boolean;

  /**
   * Whether to fetch the offer list or just return existing offer list
   */
  noFetch?: boolean;
}

function useOfferListFilters(filters: App.OfferListFilters, options: Options = EmptyObject): App.OfferListFilterOptions {
  const key = getOfferListKey(filters)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!options.disabled && !options.noFetch && !filters?.isStream) {
      dispatch(fetchOfferListFilters(filters))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, options])

  const listFilters = useAppSelector(state => state.offer.offerListFilterOptions[key]) ?? emptyFilters

  return listFilters
}

export default useOfferListFilters
